import {
  MDBBtn,
  MDBChart,
  MDBCheckbox,
  MDBCol,
  MDBIcon,
  MDBPopconfirm,
  MDBPopconfirmMessage,
  MDBRow,
  MDBTabs,
  MDBTabsContent,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsPane,
  MDBTooltip
} from 'mdb-react-ui-kit';
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../../components/body/BodyPage";
import Conference from "../../components/images/Conference.svg";
import ConnectSessions from "../../components/images/Connect_Sessions.svg";
import InboundHandled from "../../components/images/Inbound_Handled.svg";
import International from "../../components/images/International.svg";
import MissedCalls from "../../components/images/Missed_Calls.svg";
import Outbound from "../../components/images/Outbound_Handled.svg";
import TotalFax from "../../components/images/Total_Fax.svg";
import TotalSMS from "../../components/images/Total_SMS.svg";
import TotalTalkTime from "../../components/images/Total_Talk_Time.svg";
import MainLinks from "../../components/navlinks/MainLinks";

function AnalyticsLandingPage(props) {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const [basicActive, setBasicActive] = useState('tab1');

  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }

    setBasicActive(value);
  };

  const [basicActive2, setBasicActive2] = useState('tab1');

  const handleBasicClick2 = (value) => {
    if (value === basicActive2) {
      return;
    }

    setBasicActive2(value);
  };
  return (
    <React.Fragment>
      <>
        <MainLinks active={4} />
        <Body
          tablinks={4}
          sublink={267}
          content={
            <>

              <section className="mb-3 useres-tab">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">{t("GraphicalReports")}</h5>
                  </div>
                  <div className="card-body px-0">
                    <MDBTabs className='mb-3'>
                      <MDBTabsItem>
                        <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                          {t("summary")}
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                          {t("voice")}
                        </MDBTabsLink>
                      </MDBTabsItem>

                    </MDBTabs>

                    <MDBTabsContent>
                      <MDBTabsPane open={basicActive === 'tab1'}>
                        {/* Tab 1 content */}
                        <div className="tab__border p-0">


                          <div className=" d-flex align-items-center justify-content-between mt-2">

                            <div className=" d-flex align-items-center">


                              <MDBIcon fas icon="filter" color="primary" />
                              <label className="m-0 ms-2">{t('filters')}</label>


                              <div className="ms-4 popconfirmFilter reportsAdjust">

                                <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' btnChildren={<>
                                  <div className=" reportsFilter form-select selectname">
                                    Talk Time &gt; 0 Sec(s): Ring Time &gt; 0  Sec(s)
                                  </div>
                                </>}>
                                  <MDBPopconfirmMessage>
                                    <div>
                                      <div className="mt-2 d-flex align-items-center">
                                        <MDBCheckbox name='inlineCheck' id='inlineCheckbox1' value='option1' label='Show 999x Calls' />
                                        <MDBTooltip tag='a' wrapperProps={{ href: '#' }} placement='left' title=" Show calls to numbers(s): 9997, 9998, 9999, mwi">
                                          <MDBIcon far icon="question-circle" className="ms-2" />
                                        </MDBTooltip>
                                      </div>

                                      <div className="mt-2 d-flex align-items-center">
                                        <div className="w-25">
                                          <MDBCheckbox name='inlineCheck' id='inlineCheckbox2' value='option2' label='Talk Time' />
                                        </div>
                                        <select className="ms-2 form-select w-auto reportsFilterSelect">
                                          <option value="">Greater than </option>
                                          <option value="">Less then</option>
                                        </select>
                                        <input type="text" className="ms-2 w-20 reportsFilterInput" />
                                        <p className="m-0 ms-2">Sec(s)</p>
                                      </div>

                                      <div className="mt-2 d-flex align-items-center">
                                        <div className="w-25">
                                          <MDBCheckbox name='inlineCheck' id='inlineCheckbox3' value='option3' label='Ring Time' />
                                        </div>
                                        <select className="ms-2 form-select w-auto reportsFilterSelect">
                                          <option value="">Greater than </option>
                                          <option value="">Less then</option>
                                        </select>
                                        <input type="text" className="ms-2 w-20 reportsFilterInput" />
                                        <p className="m-0 ms-2">Sec(s)</p>
                                      </div>

                                      <div className="d-flex align-items-center justify-content-center mt-3">
                                        <MDBBtn size="sm"> Apply</MDBBtn>
                                        <MDBBtn size="sm" color="secondary" className="ms-3"> Clear</MDBBtn>
                                        <MDBBtn size="sm" color="secondary" className="ms-3"> Close</MDBBtn>
                                      </div>

                                    </div>


                                  </MDBPopconfirmMessage>
                                </MDBPopconfirm>
                              </div>
                            </div>



                            <div className=" d-flex align-items-center">
                              <MDBIcon fas icon="calendar-alt" color="primary" />
                              <label className="m-0 ms-2">{t('period')}: </label>
                              <select className="ms-2 form-select selectname w-auto">
                                <option value="">Greater than </option>
                                <option value="">Less then</option>
                              </select>
                              <p className="m-0 ms-2">Displaying data until
                                <b>
                                  Dec 31, 2023 23:59:59
                                </b>
                              </p><MDBIcon fas icon="redo" className="ms-2" />
                            </div>
                          </div>
                          <div className="mt-3">
                            <p className="m-0">
                              Load Time: 0s | Processing Time: 2.799s | Display Time: 0.314s | Totoal Time: 3.391s | Status : Completed
                            </p>
                          </div>


                          <div className="w-100 reportsCards">


                            <div className="reportsCardsData">
                              <div className="reportsCardsHead">
                                <h5 className="m-0 ps-3">
                                  Inbound Handled
                                </h5>

                                <div className="reportsCardsHead-icon">
                                  <img src={InboundHandled} alt="" />
                                </div>
                              </div>
                              <div className="p-4 py-3">
                                <h3 className="text-primary m-0">2</h3>
                                <b>Handled</b>
                                <div className="d-flex align-items-center justify-content-between mt-2">
                                  <p>Talk time: 0.83 Mins</p>
                                  <p>Avg: 0.4 Mins</p>
                                </div>
                              </div>
                            </div>

                            <div className="reportsCardsData">
                              <div className="reportsCardsHead">
                                <h5 className="m-0 ps-3">
                                  Missed Calls
                                </h5>

                                <div className="reportsCardsHead-icon missedCall">
                                  <img src={MissedCalls} alt="" />
                                </div>
                              </div>
                              <div className="p-4 py-3">
                                <h3 className="text-primary m-0">1</h3>
                                <b>Handled</b>

                              </div>
                            </div>

                            <div className="reportsCardsData">
                              <div className="reportsCardsHead">
                                <h5 className="m-0 ps-3">
                                  International
                                </h5>

                                <div className="reportsCardsHead-icon international">
                                  <img src={International} alt="" />
                                </div>
                              </div>
                              <div className="p-4 py-3">
                                <h3 className="text-primary m-0">2</h3>
                                <b>Handled</b>

                              </div>
                            </div>


                            <div className="reportsCardsData">
                              <div className="reportsCardsHead">
                                <h5 className="m-0 ps-3">
                                  Outbound Handled
                                </h5>

                                <div className="reportsCardsHead-icon Outbound">
                                  <img src={Outbound} alt="" />
                                </div>
                              </div>
                              <div className="p-4 py-2">
                                <h3 className="text-primary m-0">9</h3>
                                <b>Handled</b>
                                <div className="d-flex align-items-start justify-content-between mt-2">
                                  <div>
                                    <p className="m-0">Talk time: 28.8 Mins</p>
                                    <small className="d-block">(Includes International)</small>
                                  </div>
                                  <p>Avg: 3 Mins</p>
                                </div>
                              </div>
                            </div>

                            <div className="reportsCardsData">
                              <div className="reportsCardsHead">
                                <h5 className="m-0 ps-3">
                                  Total Talk Time
                                </h5>

                                <div className="reportsCardsHead-icon TotalTalkTime">
                                  <img src={TotalTalkTime} alt="" />
                                </div>
                              </div>
                              <div className="p-4 py-3">
                                <h3 className="text-primary m-0">9</h3>
                                <b>Handled</b>
                                <div className="d-flex align-items-start justify-content-between mt-2">

                                  <p className="m-0">Talk time: 28.8 Mins</p>

                                  <p>Avg: 3 Mins</p>
                                </div>
                              </div>
                            </div>

                            <div className="reportsCardsData">
                              <div className="reportsCardsHead">
                                <h5 className="m-0 ps-3">
                                  Connect Sessions
                                </h5>

                                <div className="reportsCardsHead-icon ConnectSessions">
                                  <img src={ConnectSessions} alt="" />
                                </div>
                              </div>
                              <div className="p-4 py-3">
                                <h3 className="text-primary m-0">6</h3>
                                <b>Handled</b>
                                <div className="d-flex align-items-start justify-content-between mt-2">

                                  <p className="m-0">Total Participants: 9</p>

                                  <p>Avg: 7.2 Mins</p>
                                </div>
                              </div>
                            </div>

                            <div className="reportsCardsData">
                              <div className="reportsCardsHead">
                                <h5 className="m-0 ps-3">
                                  Conference
                                </h5>

                                <div className="reportsCardsHead-icon Conference">
                                  <img src={Conference} alt="" />
                                </div>
                              </div>
                              <div className="p-4 py-3">
                                <h3 className="text-primary m-0">0</h3>
                                <b>Handled</b>
                                <div className="d-flex align-items-start justify-content-between mt-2">

                                  <p className="m-0">Talk time: 0 Mins</p>

                                  <p>Avg: 0 Mins</p>
                                </div>
                              </div>
                            </div>

                            <div className="reportsCardsData">
                              <div className="reportsCardsHead">
                                <h5 className="m-0 ps-3">
                                  Total SMS
                                </h5>

                                <div className="reportsCardsHead-icon TotalSMS">
                                  <img src={TotalSMS} alt="" />
                                </div>
                              </div>
                              <div className="p-4 py-3">
                                <h3 className="text-primary m-0">2</h3>
                                <b>Handled</b>
                                <div className="d-flex align-items-start justify-content-between mt-2">

                                  <p className="m-0">Inbound: 0</p>

                                  <p>Outbound: 2</p>
                                </div>
                              </div>
                            </div>

                            <div className="reportsCardsData">
                              <div className="reportsCardsHead">
                                <h5 className="m-0 ps-3">
                                  Total Fax
                                </h5>

                                <div className="reportsCardsHead-icon TotalFax">
                                  <img src={TotalFax} alt="" />
                                </div>
                              </div>
                              <div className="p-4 py-3">
                                <h3 className="text-primary m-0">2</h3>
                                <b>Handled</b>
                                <div className="d-flex align-items-start justify-content-between mt-2">

                                  <p className="m-0">Pages: 2</p>

                                </div>
                              </div>
                            </div>
                          </div>



                          {/*----------------------- Graphs ---------------------*/}
                          <div className="mt-4">
                            <MDBRow>
                              <MDBCol lg={6} sm={12} md={6}>
                                <p className="m-0">
                                  Load Time: 0s | Processing Time: 2.799s | Display Time: 0.314s | Totoal Time: 3.391s | Status : Completed
                                </p>
                                <MDBChart
                                  type='bar'
                                  options={{
                                    scales: {
                                      x: {
                                        ticks: {
                                          color: '#4285F4',
                                        },
                                      },
                                      y: {
                                        ticks: {
                                          color: '#f44242',
                                        },
                                      },
                                    },
                                  }}
                                  data={{
                                    labels: ['Inbound Handled', 'Missed Calls', 'International', 'Outbound Handled', 'Total Talk Time', 'Connect Sessions'],
                                    datasets: [
                                      {
                                        label: 'Traffic',
                                        data: [30, 15, 62, 65, 61, 6],
                                        backgroundColor: [
                                          'rgba(255, 99, 132, 0.2)',
                                          'rgba(54, 162, 235, 0.2)',
                                          'rgba(255, 206, 86, 0.2)',
                                          'rgba(75, 192, 192, 0.2)',
                                          'rgba(153, 102, 255, 0.2)',
                                          'rgba(255, 159, 64, 0.2)',
                                        ],
                                        borderColor: [
                                          'rgba(255,99,132,1)',
                                          'rgba(54, 162, 235, 1)',
                                          'rgba(255, 206, 86, 1)',
                                          'rgba(75, 192, 192, 1)',
                                          'rgba(153, 102, 255, 1)',
                                          'rgba(255, 159, 64, 1)',
                                        ],
                                        borderWidth: 1,
                                      },
                                    ],
                                  }}
                                />
                              </MDBCol>
                              <MDBCol lg={6} sm={12} md={6}>
                                <p className="m-0">
                                  Load Time: 0s | Processing Time: 2.799s | Display Time: 0.314s | Totoal Time: 3.391s | Status : Completed
                                </p>
                                <MDBChart
                                  type='bar'
                                  options={{
                                    scales: {
                                      x: {
                                        ticks: {
                                          color: '#4285F4',
                                        },
                                      },
                                      y: {
                                        ticks: {
                                          color: '#f44242',
                                        },
                                      },
                                    },
                                  }}
                                  data={{
                                    labels: ['Inbound Handled', 'Missed Calls', 'International', 'Outbound Handled', 'Total Talk Time', 'Connect Sessions'],
                                    datasets: [
                                      {
                                        label: 'Handled',
                                        data: [30, 15, 62, 65, 61, 6],
                                        backgroundColor: [
                                          'rgba(255, 99, 132, 0.2)',
                                          'rgba(54, 162, 235, 0.2)',
                                          'rgba(255, 206, 86, 0.2)',
                                          'rgba(75, 192, 192, 0.2)',
                                          'rgba(153, 102, 255, 0.2)',
                                          'rgba(255, 159, 64, 0.2)',
                                        ],
                                        borderColor: [
                                          'rgba(255,99,132,1)',
                                          'rgba(54, 162, 235, 1)',
                                          'rgba(255, 206, 86, 1)',
                                          'rgba(75, 192, 192, 1)',
                                          'rgba(153, 102, 255, 1)',
                                          'rgba(255, 159, 64, 1)',
                                        ],
                                        borderWidth: 1,
                                      },
                                    ],
                                  }}
                                />
                              </MDBCol>
                            </MDBRow>
                          </div>
                        </div>
                      </MDBTabsPane>


                      {/* ------------------ TAB CHANGE ---------------- */}


                      <MDBTabsPane open={basicActive === 'tab2'}>
                        {/* Tab 2 content */}
                        <div className="tab-margin-3">

                          <MDBTabs className='mb-3'>
                            <MDBTabsItem>
                              <MDBTabsLink onClick={() => handleBasicClick2('tab1')} active={basicActive2 === 'tab1'}>
                                {t('CallDetailsReport')}
                              </MDBTabsLink>
                            </MDBTabsItem>
                            <MDBTabsItem>
                              <MDBTabsLink onClick={() => handleBasicClick2('tab2')} active={basicActive2 === 'tab2'}>
                                {t('GroupVoiceMails')}
                              </MDBTabsLink>
                            </MDBTabsItem>
                          </MDBTabs>
                        </div>

                        <MDBTabsContent>
                          <MDBTabsPane open={basicActive2 === 'tab1'}>Tab 1 content</MDBTabsPane>
                          <MDBTabsPane open={basicActive2 === 'tab2'}>Tab 2 content</MDBTabsPane>
                        </MDBTabsContent>


                      </MDBTabsPane>
                    </MDBTabsContent>
                  </div>
                </div>
              </section>
            </>
          }
        />
        {/* <Footer /> */}
      </>
    </React.Fragment>
  );
}

export default AnalyticsLandingPage;
